export default __webpack_public_path__ + "static/media/hero-bg-2.f3ec55a9.webp";